import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "View job quotes"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "List of all saved job quotes")
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "table-responsive w-100" }
const _hoisted_5 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, "Title"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, " Company "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-lg-100px" }, "Address"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px text-end" }, "Actions")
  ])
], -1)
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = {
  class: "btn-group btn-group-sm pb-2 pt-1",
  role: "group"
}
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle me-2"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Generate ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "w-100 mt-4 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteQuoteModal = _resolveComponent("DeleteQuoteModal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteQuoteModal, {
      onDeleted: _ctx.updateRows,
      ref: "deleteQuoteModal"
    }, null, 8, ["onDeleted"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotes, (quote) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: quote.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(quote.title), 1),
                  _createElementVNode("td", null, _toDisplayString(quote.company), 1),
                  _createElementVNode("td", null, _toDisplayString(quote.address), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        disabled: _ctx.isGenerating(quote.id),
                        type: "button",
                        onClick: ($event: any) => (_ctx.handleGenerate(quote.id)),
                        class: "btn btn-sm btn-success"
                      }, [
                        (_ctx.isGenerating(quote.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                          : _createCommentVNode("", true),
                        _hoisted_11
                      ], 8, _hoisted_9),
                      _createVNode(_component_router_link, {
                        to: `/edit-quote/${quote.id}`,
                        class: "btn btn-sm btn-warning"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.handleDelete(quote)),
                        class: "btn btn-sm btn-danger"
                      }, " Delete ", 8, _hoisted_13)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Pagination, {
            currentPage: _ctx.pagination.current,
            totalPages: _ctx.pagination.total,
            onChangeCurrentPage: _ctx.handleChangePage
          }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ], 64))
}